import React from "react"
import "typeface-allerta-stencil"
import { graphql, Link } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/top-layout"

import SEO from "../components/seo"


export default ({ data }) => (
<Layout>
  <SEO />
  <section className="hero">
    <figure>
    {/* <svg width="2005" height="1253" viewBox="0 0 2005 1253" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-233.612" y="-218.191" width="2566.38" height="1603.99" fill="#E2ECF6"/><g filter="url(#filter0_d)"><path d="M-281.732 467.793C-186.351 348.359 76.8609 141.934 366.67 271.707C728.93 433.924 1005.76 -618.186 1312.22 294.881C1640.38 1272.62 1685.31 708.454 2202.66 528.553C2615.24 385.086 2814.71 991.039 2830 974.996" stroke="#EBC6F1" stroke-width="0.5"/></g><g filter="url(#filter1_d)"><path d="M2075.99 -374.565C2089.66 -226.122 2046.27 86.3441 1763.44 148.662C1409.89 226.559 1913.99 1214.02 1104.14 667.77C236.915 82.8283 577.733 553.5 343.782 989.478C157.211 1337.16 -377.586 972.425 -377.435 993.771" stroke="#EBC6F1" stroke-width="0.5"/></g><g filter="url(#filter2_d)"><path d="M646.924 2172.93C643.631 2066.29 691.224 1828.84 907.935 1732.17C1178.82 1611.34 844.628 976.282 1430.81 1232.08C2058.52 1506 1823.24 1221.38 2020.71 858.887C2178.18 569.804 2565.09 741.673 2565.98 726.013" stroke="#EBC6F1" stroke-width="0.5"/></g><g filter="url(#filter3_d)"><path d="M-386.486 658.242C-264.583 597.436 10.5422 531.211 135.814 752.768C292.403 1029.71 997.219 271.417 743.668 1145.55C472.156 2081.6 782.29 1634.07 1210.7 1690.16C1552.34 1734.89 1381.51 2313.46 1399.51 2306.27" stroke="#EBC6F1" stroke-width="0.5"/></g><defs><filter id="filter0_d" x="-287.927" y="-85.6819" width="3124.11" height="1070.24" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="3"/><feGaussianBlur stdDeviation="3"/><feColorMatrix type="matrix" values="0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0.3 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter><filter id="filter1_d" x="-383.95" y="-778.324" width="2828.5" height="2615.73" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="3"/><feGaussianBlur stdDeviation="3"/><feColorMatrix type="matrix" values="0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0.3 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter><filter id="filter2_d" x="387.417" y="234.757" width="2185.01" height="2181.68" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="3"/><feGaussianBlur stdDeviation="3"/><feColorMatrix type="matrix" values="0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0.3 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter><filter id="filter3_d" x="-645.31" y="201.137" width="2577.24" height="2114.71" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="3"/><feGaussianBlur stdDeviation="3"/><feColorMatrix type="matrix" values="0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0.3 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg> */}
      <section className="font-Allerta-Stencil">
        <Link to={`/`}>
          <div className="logo">Tyler Blog</div>
        </Link>
        <Link to={`/about/`}><div className="about circle neumorphism">About</div></Link>
        <Link to={`/blog/`}><div className="blog circle neumorphism">Blog</div></Link>
        <Link to={`/cat/portfolio/`}><div className="topportfolio circle neumorphism">Portfolio</div></Link>
        <Link to={`https://4sf023busxd.typeform.com/to/VEPcEgua`} target="_blank" rel="noopener"><div className="contact circle neumorphism">Contact</div></Link>
      </section>
    </figure>
  </section>
  {/* <section className="food">
    <div className="container">
      <h2 className="bar">Food <span>Essence</span></h2>
      <div className="details">
        <div className="detail">
          <figure>
            <Img fluid={data.fruit.childImageSharp.fluid} alt="" />
          </figure>
          <h3>フルーツ</h3>
          <p>FRUIT</p>
          <p>甘くてすっぱくておいしい果実たち。<br />旬のフルーツを満喫します。</p>
        </div>
        <div className="detail">
          <figure>
            <Img fluid={data.grain.childImageSharp.fluid} alt="" />
          </figure>
          <h3>穀物</h3>
          <p>GRAIN</p>
          <p>食事の基本となる穀物。<br />毎日の活動のエネルギー源になります。</p>
        </div>
        <div className="detail">
          <figure>
            <Img fluid={data.beverage.childImageSharp.fluid} alt="" />
          </figure>
          <h3>飲み物</h3>
          <p>BEVERAGE</p>
          <p>リラックスするのに欠かせない飲み物。<br />お気に入りの一杯はありますか？</p>
        </div>
      </div>
    </div>
  </section> */}
  {/* <section className="photo">
    <h2 className="sr-only">Photo</h2>
    <figure>
      <Img fluid={data.berry.childImageSharp.fluid} alt="赤く熟したベリー" style={{ height: "100%" }}/>
    </figure>
  </section> */}

  <section className="recentpost">
            <div className="container">
                <h2 className="bar font-Allerta-Stencil">Recent Blog</h2>
                <div className="posts">
                    {data.allContentfulBlogPost.edges.map(({ node }) => (

                        <article className="post" key={node.id}>
                            <Link to={`/blog/post/${node.slug}/`}>
                                <figure>
                                    <Img
                                        fluid={node.eyecatch.fluid}
                                        alt={node.eyecatch.description}
                                        style={{ height: "100%" , width: "100%"}}
                                    />
                                </figure>
                                <h3>{node.title}</h3>
                                <p className="first-content">{node.firstdec}...</p>
                                <div className="post-footer">
                                  <div className="categories">
                                  {node.category.map(cat => (
                                    <span className={`category ${cat.categorySlug}`} key={cat.key}>
                                      <Link to={`/cat/${cat.categorySlug}/`}>{cat.category}</Link>
                                    </span>
                                  ))}
                                  </div>
                                  <span className="pub-date">{node.publishDateJP}</span>
                                </div>
                            </Link>
                        </article>
                    )) }
                </div>
              </div>
    </section>
</Layout>
)


export const query = graphql`
  query  {
    allContentfulBlogPost(
      sort: {fields: publishDate, order: DESC}
      skip: 0
      limit: 6
      ) {
      edges {
          node {
              title
              id
              firstdec
              slug
              category {
                category
                categorySlug
                id
              }
              publishDateJP:publishDate(formatString: "YYYY年MM月DD日")
              eyecatch {
                  fluid(maxWidth: 356 ) {
                      ...GatsbyContentfulFluid_withWebp
                  }
                  description
              }
          }
      }
  }


  }
`